module.exports = __webpack_public_path__ + "assets/fonts/stop.2387977d.svg";